import { Directive, inject, input, linkedSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[entityBoardTopLevel]',
  standalone: true,
  host: {
    '[class.entity-board-top-level]': '$topLevel()',
  },
})
export class EntityBoardTopLevelDirective {

  public $topLevelOverride = input(false, { alias: 'topLevelOverride' });

  private route = inject(ActivatedRoute);

  private $routeData = toSignal(this.route.data);
  protected $topLevel = linkedSignal(() => {
    return this.$topLevelOverride() || this.$routeData()?.topLevel;
  });
}
